import { useStoreMap } from 'effector-react';
import { ImageType, type SceneData } from '@types';
import Image from '@components/Image';
import { $sceneMap } from '@stores/dataStores';
import type { DragItemScenes } from '../dnd';

interface Props {
  ids: DragItemScenes['ids'];
}

export function DraggingItem({ ids }: Props) {
  const scenes = useStoreMap({
    store: $sceneMap,
    keys: [ids],
    fn: (state, [_ids]) => {
      return _ids.map((x) => state.get(x.id)).filter(Boolean) as SceneData[];
    },
  });

  if (scenes.length === 1) {
    const item = scenes[0];
    return (
      <div className="z-20 flex items-center justify-between whitespace-nowrap rounded border bg-white p-10 shadow-md">
        <div className="flex min-w-0 items-center gap-10">
          <Image
            className="h-32 w-32 shrink-0"
            src={item.thumbUrl}
            type={ImageType.thumb}
            size={32}
          />
          <div className="max-w-[300px] truncate" title={item.name}>
            {item.name}
          </div>
        </div>
      </div>
    );
  }

  if (scenes.length > 1) {
    const name = scenes.map((x) => x.name).join('、');
    return (
      <div className="z-20 flex items-center justify-between whitespace-nowrap rounded border bg-white p-10 shadow-md">
        <div className="flex min-w-0 items-center gap-10">
          <ItemStack items={scenes} />
          <div className="max-w-[300px] truncate" title={name}>
            {name}
          </div>
          {`等${scenes.length}个场景`}
        </div>
      </div>
    );
  }

  return null;
}

function ItemStack({ items }: { items: SceneData[] }) {
  const displayItems = items.slice(0, 3).reverse();
  return (
    <div
      className="relative shrink-0"
      style={{
        height: 32 + displayItems.length * 3,
        width: 32 + displayItems.length * 3,
      }}
    >
      {displayItems.map((item, index) => (
        <Image
          key={item.id}
          className="absolute h-32 w-32"
          src={item.thumbUrl}
          type={ImageType.thumb}
          size={32}
          style={{
            right: `${index * 3}px`,
            bottom: `${index * 3}px`,
          }}
        />
      ))}
    </div>
  );
}

export default DraggingItem;
